import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';

import { UiService } from './ui.service';
import { Feature } from '@classes/feature';
import { Client } from '@classes/client';
import { User } from '@classes/user/user';


@Injectable({
  providedIn: 'root'
})
export class FeaturesService {
  private baseUrl: string = environment.apiUrl + 'features';
  private clientsUrl: string = environment.apiUrl + 'clients';
  private usersUrl: string = environment.apiUrl + 'users';
  private features: Feature[];

  constructor(
    private http: HttpClient,
    private uiSrv: UiService
  ) { }

  get(): Observable<Feature[]> {
    return this.http.get<Feature[]>(this.baseUrl)
      .pipe(
        map(features => {
          this.features = features;
          return [...this.features];
        })
      );
  }

  getByClient(clientId: string): Observable<Feature[]> {
    return this.http.get<Feature[]>(`${this.clientsUrl}/${clientId}/features`)
      .pipe(
        map(features => {
          this.features = features;
          return [...this.features];
        })
      );
  }

  putClientFeatures(clientId: string, featuresId: Feature): Observable<Client> {
    return this.http.put<Client>(`${this.clientsUrl}/${clientId}/features`, featuresId);
  }

  getByUser(userId: string): Observable<Feature[]> {
    return this.http.get<Feature[]>(`${this.usersUrl}/${userId}/features`)
      .pipe(
        map(features => {
          this.features = features;
          return [...this.features];
        })
      );
  }

  putUserFeatures(userId: string, featuresId: Feature): Observable<User> {
    return this.http.put<User>(`${this.usersUrl}/${userId}/features`, featuresId);
  }
}
